<div class="client-payment-profile-table--container">
  <table class="lum-table lum-table--classic">
    <tbody>
      <ng-container *ngFor="let card of cards; trackBy: trackById">
        <tr>
          <td class="w-20">
            <img class="card-img" src="/assets/images/card.png" alt="" />
          </td>
          <td>
            <div class="card-info flex flex-column">
              <span>{{ card.label }}</span>
              <span class="font-semi-bold">{{
                card.lastFourDigits | maskCardNumber
              }}</span>
            </div>
          </td>
          <td>
            <div class="card-info">
              <span>{{ card | formatCardExpiry }}</span>
            </div>
          </td>
          <td>
            <div class="flex align-items-center justify-end gap-4">
              <input
                type="radio"
                name="defaultCard"
                class="lum-radio"
                [checked]="card.default"
                (change)="onSelectDefaultCard(card)"
              />
              <button
                mat-icon-button
                [matMenuTriggerFor]="menu"
                aria-label="Billing info action menu"
              >
                <mat-icon>more_vert</mat-icon>
              </button>
              <mat-menu #menu="matMenu">
                <button mat-menu-item (click)="onManageCard(card, 'edit')">
                  <span>Edit</span>
                </button>
                <button mat-menu-item (click)="onManageCard(card, 'delete')">
                  <span>Delete</span>
                </button>
              </mat-menu>
            </div>
          </td>
        </tr>
      </ng-container>
    </tbody>
  </table>
</div>
